import type { Messages } from './messages.en';

export const pt: Messages = {
  'home.title': "L'Infiltré",
  'home.subtitle': 'Crise no bairro. Escolha um modo.',
  'home.resume.eyebrow': 'Retomar',
  'home.resume.label': 'Continuar partida guardada',
  'home.standalone.eyebrow': 'Local',
  'home.standalone.label': 'Jogar neste dispositivo',
  'home.standalone.description': 'Funciona offline. Um dispositivo, vários jogadores.',
  'home.online.eyebrow': 'Online',
  'home.online.label': 'Sala privada',
  'home.online.description': 'Em breve.',
  'home.version': 'v0.0.0',
  'home.players_minutes': '3–12 jogadores · 5 min / ronda',
  'home.eyebrow': 'Crise · Infiltrés entre os Flics',
  'home.lede':
    'Os Flics partilham uma palavra-chave. Um Infiltré vê outra parecida — mas diferente. Descobre-o antes que te aponte o dedo.',
  'home.tagline.same_word': 'Mesma palavra-chave. Quase.',
  'home.tagline.almost': 'Um de vocês está infiltrado.',
  'home.tagline.spot_the_imposter': 'Descobre o Infiltré.',
  'home.rules.cta': 'Como jogar',

  'rules.eyebrow': 'Briefing · 30 segundos',
  'rules.title': 'Como jogar',
  'rules.sub': 'Três regras. Um Infiltré. Não te deixes apanhar.',
  'rules.step1.title': 'Cada jogador recebe uma palavra secreta.',
  'rules.step1.body':
    'Os Flics partilham uma palavra-chave. O Infiltré vê uma parecida — mas diferente. O Clochard não vê nada: um vagabundo do bairro que tenta apenas adivinhar.',
  'rules.step2.title': 'Descreve a tua palavra à vez.',
  'rules.step2.body':
    'Uma palavra, sem rimas nem soletrar. Os Infiltrés têm de improvisar sem se denunciar.',
  'rules.step3.title': 'Vota para expulsar o Infiltré.',
  'rules.step3.body':
    'Após as pistas, a mesa vota. Se eliminares o Clochard, tem uma última hipótese de adivinhar a palavra dos Flics e roubar a vitória.',
  'rules.footer': 'Ideal entre 4 e 8 amigos. Passa o dispositivo. Não confies em ninguém.',
  'rules.got_it': 'Percebi',

  'setup.count.heading': 'Quantos jogadores?',
  'setup.count.hint': 'Toca no número e passa o dispositivo',
  'setup.count.cta': 'Passa o dispositivo ao jogador 1',
  'setup.slot.player_label': 'Jogador {n}',
  'setup.slot.hint': 'Mantém pressionado para escrever o teu nome',
  'setup.slot.welcome': 'Escreve o teu nome',
  'setup.slot.name_placeholder': 'O teu nome',
  'setup.slot.confirm': 'Confirmar — passar o dispositivo',
  'setup.slot.duplicate_error': 'Este nome já está em uso.',

  'setup.players.heading': 'Jogadores',
  'setup.players.hint': 'Introduz cada jogador. O primeiro nome é o anfitrião.',
  'setup.players.host_placeholder': 'Nome do anfitrião',
  'setup.players.player_placeholder': 'Jogador {index}',
  'setup.players.add': '+ Adicionar jogador',
  'setup.players.duplicate_error': 'Os nomes têm de ser únicos.',

  'setup.briefing.eyebrow': 'Preparação',
  'setup.briefing.title': 'Sala de briefing',
  'setup.briefing.settings': 'Definições',
  'setup.host_settings.title': 'Definições da sala',
  'setup.host_settings.eyebrow': 'Controlos do anfitrião · ficheiro',
  'setup.host_settings.hint': 'Afina a ronda antes de distribuir. Só o anfitrião vê isto.',
  'setup.host_settings.lock_in': 'Confirmar',
  'setup.host_settings.section.mode': 'Modo de jogo',
  'setup.host_settings.section.roles': 'Papéis',
  'setup.host_settings.section.pace': 'Ritmo',
  'setup.host_settings.section.word_pack': 'Pacote de palavras',
  'setup.host_settings.infiltre_hint': 'Mente sobre uma palavra parecida',
  'setup.host_settings.clochard_label': 'Incluir Clochard',
  'setup.host_settings.clochard_hint':
    'Vagabundo do bairro. Não sabe nada. Pode roubar a vitória ao adivinhar a palavra dos Flics.',
  'setup.host_settings.timer_hint': 'Segundos por ronda · 0 = sem temporizador',
  'setup.host_settings.timer_off': 'Off',
  'category.animals': 'Animais',
  'category.food': 'Comida',
  'category.objects': 'Objetos',
  'category.geography': 'Geografia',
  'category.nature': 'Natureza',
  'category.sports': 'Desportos',
  'category.movies': 'Filmes',
  'category.slang': 'Calão',
  'setup.briefing.headline_top': 'Sala de',
  'setup.briefing.headline_bottom': 'briefing.',
  'setup.briefing.lede':
    'Recruta os teus suspeitos. Toca numa polaroid para renomear. As palavras estão seladas — mesmo do anfitrião.',
  'setup.briefing.recruit': 'Recrutar',
  'setup.briefing.suspects': 'Suspeitos',
  'setup.briefing.need_more': 'Recruta mais {needed}',
  'setup.briefing.deal_cards': 'Iniciar ronda',
  'setup.briefing.sealed_hint': 'Par de palavras selado — ninguém vê ainda.',
  'setup.mugshot.customize_aria': 'Personalizar retrato',
  'setup.mugshot.title': 'Retrato-robô',
  'setup.mugshot.phase': 'Ficha 01',
  'setup.mugshot.subtitle': 'identidade do suspeito',
  'setup.mugshot.section.identity': 'Identidade',
  'setup.mugshot.section.features': 'Sinais',
  'setup.mugshot.randomize': 'Aleatório',
  'setup.mugshot.close': 'Fechar',
  'setup.mugshot.done': 'Pronto',
  'setup.mugshot.category.menton': 'Queixo',
  'setup.mugshot.category.nez': 'Nariz',
  'setup.mugshot.category.bouche': 'Boca',
  'setup.mugshot.category.moustache': 'Bigode',
  'setup.mugshot.category.yeux': 'Olhos',
  'setup.mugshot.category.sourcils': 'Sobrancelhas',
  'setup.mugshot.category.cheveux': 'Cabelo',
  'setup.mugshot.category.accessoire': 'Acessório',
  'setup.recruit.sealed_eyebrow': 'Selado · não abrir',

  'setup.options.heading': 'Opções',
  'setup.options.include_clochard': 'Incluir Clochard',
  'setup.options.discussion_seconds': 'Temporizador de discussão',
  'setup.options.discussion_seconds_hint': 'Segundos antes da votação. 0 = manual.',
  'setup.options.locale': 'Idioma',

  'locale.en': 'English',
  'locale.fr': 'Français',
  'locale.es': 'Español',
  'locale.de': 'Deutsch',
  'locale.pt': 'Português',

  'setup.start': 'Começar partida',

  'play.no_active_game': 'Sem partida ativa.',
  'play.go_home': 'Voltar ao início',
  'play.connecting': 'A ligar…',
  'play.phase_label': 'Fase: {phase}',

  'play.privacy_gate.pass_to': 'Passar a',
  'play.privacy_gate.hold_to_reveal': 'Mantém premido para revelar',
  'play.privacy_gate.tap_to_reveal': 'Toca para revelar',
  'play.privacy_gate.hold_to_see_word': 'Mantém premido para ver a tua palavra',
  'play.privacy_gate.tap_to_see_word': 'Toca para ver a tua palavra',
  'play.privacy_gate.hold_to_vote': 'Mantém premido para votar',
  'play.privacy_gate.done': 'Pronto — passa o dispositivo',
  'play.pass_device.eyebrow': 'Passar o dispositivo a',
  'play.pass_device.dossier': 'Dossiê · {n}/{total}',
  'play.pass_device.no_peeking': '— Sem espreitar. As paredes têm ouvidos.',
  'play.pass_device.ready': 'Estou pronto',

  'play.handoff.all_done_eyebrow': 'Todos os jogadores prontos',
  'play.handoff.all_revealed_title': 'Todos os jogadores prontos',
  'play.handoff.all_revealed_description': 'Hora de discutir. Falem por turnos.',
  'play.handoff.continue': 'Continuar',
  'play.handoff.all_voted_title': 'Todos os votos registados',
  'play.handoff.all_voted_description': 'Toca para revelar.',
  'play.handoff.reveal': 'Revelar',

  'pause.button': 'Pausa',
  'pause.eyebrow': 'Pausa · à parte',
  'pause.title': 'Respira fundo.',
  'pause.sub': 'Continua ou desliga.',
  'pause.resume.label': 'Continuar',
  'pause.resume.sub': 'Volta à ação.',
  'pause.rules.label': 'Como jogar',
  'pause.rules.sub': 'Relembra as regras.',
  'pause.quit.label': 'Sair',
  'pause.quit.sub': 'Termina a partida. Preferências guardadas.',
  'pause.recap.label': 'Resumo',
  'pause.recap.sub': 'Vê o dossier.',

  'recap.eyebrow_between': 'Dossier · ronda fechada',
  'recap.eyebrow_end': 'Dossier · completo',
  'recap.title_between': 'Resumo da ronda',
  'recap.title_end': 'Como decorreu',
  'recap.sub_between': 'O que aconteceu. Aproveita ou não.',
  'recap.sub_end': 'Cada ronda, cada eliminação, por ordem.',
  'recap.empty': 'Ainda não há rondas — dossier vazio.',
  'recap.still_in_room': 'Ainda em jogo',
  'recap.eliminated_meta': 'Eliminado · {count} restantes',
  'recap.round_short': 'Rd',
  'recap.close': 'Fechar',

  'round.your_role': 'O teu papel',
  'round.your_card': 'A tua carta',
  'round.your_word': 'A tua palavra',
  'round.no_word': 'Sem palavra',
  'round.no_word_hint': 'Improvisa no bluff.',

  'round.speaking.heading': 'Ordem de palavra',
  'round.speaking.hint': 'Cada jogador dá uma pista por turno. Não digas a palavra diretamente.',
  'round.speaking.ready_to_vote': 'Prontos para votar',
  'round.speaking.order_eyebrow': 'POR ORDEM',
  'round.speaking.order_title': 'À volta da mesa',

  'round.vote.eyebrow': '{name} — o teu voto',
  'round.vote.heading': 'Apanha o Infiltré',

  'round.result.eyebrow': 'Ronda fechada',
  'round.result.complete_eyebrow': 'Dossiê',
  'round.result.voted_out_eyebrow': 'Eliminado',
  'play.clochard.spotlight': 'No holofote',
  'play.clochard.last_words': '{name}, últimas palavras.',
  'play.clochard.one_guess': 'Uma tentativa',
  'round.result.cast_eyebrow': 'elenco revelado',
  'round.result.suspects_count': 'suspeitos',
  'round.result.win_team.flic': 'FLICS',
  'round.result.win_team.infiltre': 'INFILTRÉS',
  'round.result.win_team.clochard': 'CLOCHARD',
  'round.result.win_verb.flic': 'GANHAM.',
  'round.result.win_verb.infiltre': 'GANHAM.',
  'round.result.win_verb.clochard': 'GANHA.',
  'round.result.sub_flic': '— a mesa farejou-o.',
  'round.result.sub_infiltre': '— escondido à vista de todos.',
  'round.result.sub_clochard': '— uma jogada. Puro nervo.',
  'round.result.replay_cta': 'Jogar de novo',
  'round.result.new_dossier_cta': 'Novo dossiê',
  'round.result.title': 'Resultado da ronda',
  'round.result.title_finished': 'Partida terminada',
  'round.result.still_in': 'Ainda no jogo',
  'round.eliminated': 'Eliminado',
  'round.winner': 'Vencedor',
  'round.case_closed': 'Caso encerrado',
  'round.flic_word': 'Palavra dos Flics',
  'round.infiltre_word': 'Palavra dos Infiltrés',
  'round.next_round': 'Ronda seguinte',
  'round.back_home': 'Voltar ao início',
  'round.result.view_case_log_one': 'Ver dossiê · 1 ronda',
  'round.result.view_case_log_many': 'Ver dossiê · {count} rondas',
  'round.rematch': 'Revanche',
  'round.replay.button': 'Outra ronda',
  'round.replay.waiting': 'A aguardar ({count}/{needed} prontos)',
  'round.replay.requested': 'Votaste para continuar',
  'round.eliminate.heading': 'Quem foi votado?',
  'round.eliminate.eyebrow': 'Voto',
  'round.eliminate.host_hint': 'Anfitrião · toca no perdedor',
  'round.eliminate.subtitle': 'Voto em voz alta · à mesa',
  'round.eliminate.body':
    'Cada jogador vivo aponta para alguém, sem hesitar. Conta as mãos à mesa — o anfitrião toca em quem perdeu.',
  'round.eliminate.cta_idle': 'Toca num jogador',
  'round.eliminate.cta_picked': 'Eliminar {name}',
  'round.speaking.rule_eyebrow': 'Regra da ronda',
  'round.speaking.rule_line1': 'Uma palavra.',
  'round.speaking.rule_line2': 'Sem repetir.',
  'round.discuss.heading': 'Discussão',
  'round.discuss.eyebrow_calm': 'Fala · acusa · defende',
  'round.discuss.eyebrow_danger': 'O tempo está a acabar',
  'round.discuss.seconds_label': 'Segundos',
  'round.discuss.tick_calm.0': '«Quem está a fingir?»',
  'round.discuss.tick_calm.1': '«Não acredito.»',
  'round.discuss.tick_calm.2': '«Prova.»',
  'round.discuss.tick_calm.3': '«Tu primeiro.»',
  'round.discuss.tick_hot.0': '«Acabou o tempo.»',
  'round.discuss.tick_hot.1': '«Escolhe.»',
  'round.discuss.tick_hot.2': '«Decide.»',

  'play.clochard.title': 'Clochard apanhado',
  'play.clochard.description': '{name}, adivinha a palavra dos Flics para vencer.',
  'play.clochard.placeholder': 'O teu palpite',
  'play.clochard.submit': 'Enviar palpite',

  'role.flic': 'Flic',
  'role.infiltre': 'Infiltré',
  'role.clochard': 'Clochard',

  'home.online_join.eyebrow': 'Online',
  'home.online_join.label': 'Entrar',
  'home.online_join.description': 'Tens um convite? Introduz o código.',

  'home.discord.eyebrow': 'Canal de voz · Activity',
  'home.discord.heading': 'Joguem com o canal',
  'home.discord.tagline': 'Todos no voz, um único dossiê.',
  'home.discord.lede': 'Todos neste canal de voz entram no mesmo dossiê.',
  'home.discord.lede_named': 'Olá {name} — leva o canal de voz para o mesmo dossiê.',
  'home.discord.start_activity': 'Entrar na sala da Activity',
  'home.discord.start_busy': 'A abrir o dossiê…',
  'home.discord.join_with_code': 'Entrar noutra sala com um código',
  'home.discord.no_instance': 'Activity Discord não detectada — reinicie a Activity.',
  'home.discord.sdk_failed': 'O SDK Discord não pôde iniciar. Tente novamente.',
  'home.discord.sdk_retry': 'Tentar novamente',
  'home.discord.solo_label': 'Jogar neste dispositivo',
  'home.online.unavailable': 'Modo online indisponível — servidor inacessível.',

  'online.create.eyebrow': 'Novo dossiê',
  'online.create.heading': 'Criar uma sala',
  'online.create.hint': 'Escolhe um nome. Geramos um código para partilhar.',
  'online.create.name_placeholder': 'O teu nome',
  'online.create.submit': 'Criar sala',
  'online.create.creating': 'A criar…',

  'online.join.eyebrow': 'Sala de briefing',
  'online.join.heading': 'Entrar numa sala',
  'online.join.hint': 'Introduz o código que o teu amigo partilhou.',
  'online.join.name_placeholder': 'O teu nome',
  'online.join.code_placeholder': 'CÓDIGO DA SALA',
  'online.join.submit': 'Entrar',
  'online.join.joining': 'A ligar…',

  'online.lobby.players': 'Jogadores',
  'online.lobby.briefing_room': 'Sala de briefing',
  'online.lobby.host_badge': 'Anfitrião',
  'online.lobby.you_badge': 'tu',
  'online.lobby.reconnecting_badge': 'a religar',
  'online.lobby.offline_badge': 'offline',
  'online.toast.room_not_found': 'Sala não encontrada',
  'online.toast.room_full': 'Sala cheia',
  'online.toast.kicked_after_grace': 'Ficaste desligado tempo demais',
  'online.toast.unauthorized': 'Sessão expirada',
  'online.toast.presence_online': '{name} voltou a ligar-se',
  'online.toast.presence_reconnecting': '{name} está a religar-se',
  'online.toast.presence_offline': '{name} desligou-se',
  'online.toast.server_error.actor_mismatch': 'Essa ação não é da tua sessão',
  'online.toast.server_error.unknown_player': 'Jogador não está na sala',
  'online.toast.server_error.name_required': 'O nome não pode estar vazio',
  'online.toast.server_error.invalid_message': 'Pedido inválido',
  'online.toast.server_error.unauthorized': 'Não autorizado',
  'online.toast.server_error.only_host': 'Só o anfitrião pode fazer isso',
  'online.toast.server_error.wrong_phase': 'Ação tardia — a ronda avançou',
  'online.toast.server_error.invalid_target': 'Alvo inválido',
  'online.toast.server_error.not_your_guess': 'Não é a tua vez de adivinhar',
  'online.toast.server_error.not_a_member': 'Não estás nesta sala',
  'online.toast.server_error.not_enough_players': 'Faltam jogadores',
  'online.toast.server_error.too_many_players': 'Demasiados jogadores',
  'online.toast.server_error.room_already_exists': 'A sala já existe',
  'online.toast.server_error.no_session': 'Sessão expirada — a religar',
  'online.toast.server_error.create_via_rest': 'Cria a sala na página inicial',
  'online.toast.server_error.system_only_message': 'Mensagem de sistema bloqueada',
  'online.toast.server_error.internal': 'Erro inesperado do servidor',
  'online.toast.server_error.generic': 'Erro do servidor: {message}',
  'online.lobby.waiting_host': 'À espera que o anfitrião comece…',
  'online.lobby.start_game': 'Começar partida',
  'online.lobby.need_more_players': 'São necessários pelo menos 3 jogadores',

  'online.room.code_label': 'Código da sala',
  'online.room.code_hide': 'Ocultar o código',
  'online.room.code_show': 'Mostrar o código',
  'online.room.copy': 'Copiar',
  'online.room.copied': 'Copiado!',

  'online.banner.connecting': 'A reconectar…',
  'online.banner.error': 'Ligação perdida. A tentar de novo.',

  'online.reveal.acknowledge': 'Entendido',
  'online.reveal.waiting.eyebrow': 'FASE 01 · BRIEFING',
  'online.reveal.waiting.title': 'Briefing em curso',
  'online.reveal.waiting.descriptor': '— à espera de {pending} agente(s)',
  'online.reveal.waiting.center_label': 'prontos',
  'online.discuss.host_open_vote_button': 'Prontos para votar',
  'online.discuss.waiting_host': 'À espera que o anfitrião abra a votação…',
  'online.discuss.timer_label': 'Votação em {time}',
  'online.discuss.timer_expired': 'A abrir votação…',
  'online.discuss.timer_eyebrow': 'Votação em',
  'online.vote.spectating': 'Foste eliminado. A assistir à ronda.',
  'online.vote.waiting.eyebrow': 'FASE 03 · VOTO',
  'online.vote.waiting.title': 'A contar os votos',
  'online.vote.waiting.descriptor': '— {pending} voto(s) em falta',
  'online.vote.waiting.center_label': 'votados',
  'online.clochard.spectating': '{name} arrisca o último tiro.',
  'online.round.waiting_host': 'À espera do anfitrião…',
  'online.spectator.heading': 'Espectador',
  'online.spectator.eyebrow': 'FORA DE JOGO · A OBSERVAR',
  'online.spectator.eliminated': 'Estás fora — a assistir à ronda.',
  'online.spectator.finished': 'Partida terminada.',
  'online.spectator.flic_word': 'Palavra dos Flics',
  'online.spectator.infiltre_word': 'Palavra dos Infiltrés',
  'online.spectator.phase_label': 'Fase: {phase}',
  'online.host_changed.banner': '{name} é agora o anfitrião.',
  'online.host_changed.you_banner': 'Agora és o anfitrião.',

  'platform.error.discord_unavailable': 'As funções do Discord não estão disponíveis aqui.',
  'platform.error.tauri_unavailable': 'As funções de desktop não estão disponíveis aqui.',
  'platform.error.capacitor_unavailable': 'As funções móveis não estão disponíveis aqui.',
  'platform.error.identity_failed': 'Não foi possível iniciar sessão. Tenta novamente.',
  'platform.banner.platform_label': 'A executar em {platform}',
  'platform.discord.connecting': 'A ligar ao Discord…',
  'platform.discord.authorizing': 'A autorizar com o Discord…',
  'platform.tauri.connecting': 'A carregar sessão…',
  'platform.capacitor.connecting': 'A carregar sessão…',
  'a11y.privacy_gate.aria_label': 'Mantém premido para revelar — passa para {name}',
  'a11y.vote_board.candidate_aria_label': 'Votar em {name}',
  'a11y.audio.mute_label': 'Silenciar efeitos sonoros',
  'a11y.audio.unmute_label': 'Ativar efeitos sonoros',
  'a11y.audio.volume_label': 'Volume dos efeitos',

  'nav.brand': "L'Infiltré",
  'nav.back': 'Voltar',
  'nav.home_label': 'Voltar ao início',
  'nav.settings_label': 'Abrir definições',

  'settings.title': 'Definições',
  'settings.close': 'Fechar',
  'settings.section.language': 'Idioma',
  'settings.language.subtitle': 'escolhe o idioma da interface',
  'settings.section.theme': 'Tema',
  'settings.theme.noir': 'Noir',
  'settings.theme.party': 'Festa',
  'settings.section.layout': 'Layout',
  'settings.layout.auto': 'Auto',
  'settings.layout.mobile': 'Móvel',
  'settings.layout.desktop': 'Computador',
  'settings.section.audio': 'Áudio',
  'settings.audio.mute': 'Silenciar efeitos',
  'settings.audio.volume': 'Volume',

  'mode.select.heading': 'Escolhe um modo',
  'mode.select.hint': 'Escolhe como jogar. Podes mudar nas definições.',
  'mode.select.coming_soon': 'Em breve',
  'mode.infiltre_classic.name': "L'Infiltré",
  'mode.infiltre_classic.tagline': 'Flics contra Infiltrés. Vota em quem não encaixa.',
  'mode.team_deathmatch.name': 'Combate por equipas',
  'mode.team_deathmatch.tagline': 'Duas equipas, duas palavras. Encontra os teus.',

  'briefing.phase_00': 'Fase 00 · Preparação',
  'briefing.title': 'Briefing',
  'briefing.subtitle': 'arruma a mesa antes de distribuir',
  'briefing.mode.label': 'Modo — escolhe um',
  'briefing.mode.classic': '1 Infiltrado · padrão',
  'briefing.mode.duo': '2 Infiltrados · 6+ jogadores',
  'briefing.mode.trio': '3 Infiltrados · 9+ jogadores',
  'briefing.mode.clochard': '+ Clochard · 5+ jogadores',
  'briefing.timer.label': 'Discussão · segundos',
  'briefing.clochard.label': 'Incluir um Clochard',
  'briefing.clochard.hint': '(jogador sem palavra)',
  'briefing.footer.ready': 'pronto — {count} suspeitos',
  'briefing.footer.need_more': 'faltam {count} jogadores',
  'briefing.footer.deal': 'Distribuir',
  'briefing.tape.briefing_room': 'Briefing room',
  'briefing.tape.how_to_play_l1': 'como',
  'briefing.tape.how_to_play_l2': 'jogar?',

  'round.distribution.phase_eyebrow': 'FASE 01 · DISTRIBUIÇÃO',
  'round.distribution.title': 'Distribuição',
  'round.distribution.descriptor': '— {step} de {total}',
  'round.distribution.tour': 'TURNO',
  'round.distribution.no_peeking_tape': 'NÃO ESPREITAR',
  'round.dossier.phase_eyebrow': 'FASE 01 · DOSSIÊ PESSOAL',
  'round.dossier.title': 'Dossiê',
  'round.dossier.descriptor': '— mantém o dedo para ler',
  'round.dossier.field_name': 'NOME',
  'round.dossier.field_role': 'PAPEL',
  'round.dossier.field_word': 'PALAVRA-CHAVE',
  'round.dossier.release_to_hide': '— solta para ocultar',
  'round.dossier.close_cta': 'FECHAR DOSSIÊ',
  'round.speaking.phase_eyebrow': 'FASE 02 · TURNO DE FALA',
  'round.speaking.descriptor': '— uma palavra, em voz alta, em ordem',
  'round.discuss.phase_eyebrow': 'FASE 03 · DEBATE ABERTO',
  'round.discuss.title': 'Debate',
  'round.discuss.descriptor': '— quem mente ? falem em voz alta.',
  'round.discuss.timer_eyebrow': 'CRONÓMETRO · TEMPO RESTANTE',
  'round.discuss.timer_calm_sub': '— sem pressa',
  'round.discuss.timer_danger_sub': '— o tempo está a acabar',
  'round.discuss.suspects_pill': '{count} suspeitos em jogo',
  'round.vote.phase_eyebrow': 'FASE 04 · VOTO À MESA',
  'round.vote.title': 'Voto',
  'round.vote.descriptor': '— votem em voz alta, marquem o eliminado',
  'round.verdict.phase_eyebrow': 'FASE 05 · VEREDITO',
  'round.verdict.descriptor': '— o suspeito cai',
  'round.verdict.role_revealed': 'PAPEL REVELADO',
  'round.verdict.role_tagline.flic': 'palavra real · inocente',
  'round.verdict.role_tagline.infiltre': 'palavra falsa · culpado',
  'round.verdict.role_tagline.clochard': 'sem palavra · curinga',
  'round.verdict.stamp': 'ELIMINADO',
  'round.verdict.no_elimination.title': 'Sem veredito',
  'round.verdict.no_elimination.stamp': 'PROCESSO ADIADO',
  'round.verdict.no_elimination.descriptor': '— votos divididos, o jogo continua',
  'round.verdict.no_elimination.still_in': 'Ainda em jogo',
};
